import { Item } from './Item'
import { FaPlusCircle } from 'react-icons/fa'
import { KeyValuePairs } from 'components/ideal-core-ui'
import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'

const Items = ({ onAdd, items, itemType, removeItem, changeProperty, itemCosts, updateItem }) => {
  return (
    <div style={{ marginBottom: '50px' }}>
      {items?.[itemType.value]?.length > 0 &&
        items[itemType.value].map((item, index) => (
          <Item
            index={index}
            key={item.id}
            item={item}
            removeItem={removeItem}
            changeProperty={changeProperty}
            itemType={itemType}
            itemCosts={itemCosts}
            updateItem={updateItem}
          />
        ))}
      {items?.[itemType.value]?.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'stretch' }}>
          <div style={{ width: 400, textAlign: 'center' }}>
            <KeyValuePairs
              style={{
                background: '#e8edf6'
              }}
              pairs={[
                {
                  key: 'Subtotal',
                  value: (
                    <NumericFormat
                      thousandSeparator
                      decimalScale={2}
                      value={itemCosts?.[itemType.value]?.[0]?.costs ?? 0}
                      prefix={getCurrency().symbol}
                      displayType={'text'}
                    />
                  )
                }
              ]}
            />
          </div>
          <div style={{ width: 400, textAlign: 'center' }}>
            <KeyValuePairs
              style={{
                background: '#f7fbf7'
              }}
              pairs={[
                {
                  key: 'Subtotal + Markup',
                  value: (
                    <NumericFormat
                      thousandSeparator
                      decimalScale={2}
                      value={itemCosts?.[itemType.value]?.[0]?.costsWithMarkup ?? 0}
                      prefix={getCurrency().symbol}
                      displayType={'text'}
                    />
                  )
                }
              ]}
            />
          </div>
        </div>
      )}
      <div onClick={onAdd} style={{ cursor: 'pointer', position: 'relative', top: 10 }}>
        <FaPlusCircle /> Add line item
      </div>
    </div>
  )
}

export default Items
